import { datadogRum } from '@datadog/browser-rum';
import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { datadogRumEnabled } from '@/config';

export default function User() {
  useEffect(() => {
    if (!datadogRumEnabled) {
      return;
    }
    let appState;
    try {
      appState = JSON.parse(localStorage.getItem('appState'));
    } catch {
      appState = null;
    }
    if (!appState?.isLoggedIn) {
      datadogRum.clearUser();
    }
  }, []);

  return (
    <div style={{ marginTop: '100px' }}>
      <Outlet />
    </div>
  );
}
